import React from 'react'
import { useTranslation } from 'i18n'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'

import { ChevronDown, ExternalLink } from 'lucide-react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Link from '@mui/material/Link'

import './DropDownButton2.scss'

export const DropdownButton = ({
  text,
  items,
  order,
  onClick,
  color = '#000',
  textColor = null,
  onDropdownOpen,
  menuID = 'null',
  showArrow = true,
  className = '',
  noBoxShadow = false,
  // puck (BR-5452): hover needs a stylesheet (inline background beats :hover),
  // so with hoverColor set the background moves to CSS vars consumed by
  // referral-puck.scss. All defaulted — legacy callers unchanged.
  hoverColor = null,
  extraButtonStyle = null,
  groupStyle = null,
}) => {
  const { t } = useTranslation('referral')
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const handleClick = (id, text, url) => {
    setOpen(false)

    onClick && onClick(id, text, url)
  }

  const handleToggle = (menuID, text) => {
    onDropdownOpen && onDropdownOpen(menuID, text)
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    setOpen(false)
  }
  const buttonStyle = {
    ...(hoverColor
      ? {
          '--referral-dropdown-bg': color,
          '--referral-dropdown-hover-bg': hoverColor,
        }
      : { backgroundColor: color }),
    border: 'none',
    ...(textColor ? { color: textColor } : {}),
    ...(extraButtonStyle ?? {}),
  }

  return (
    <>
      <div
        className={`content-item dropdown-button ${
          hoverColor ? 'puck-referral-dropdown' : ''
        }`}
        style={{ order: order }}
      >
        <ButtonGroup
          variant="contained"
          color="primary"
          ref={anchorRef}
          aria-label={t('dropdown.groupAriaLabel')}
          className={`themed-button-group`}
          style={{
            ...(noBoxShadow ? { boxShadow: 'none' } : {}),
            ...(groupStyle ?? {}),
          }}
        >
          <Button
            onClick={event => {
              handleToggle(menuID, text)
            }}
            style={buttonStyle}
            className={`themed-button ${className}`}
          >
            {text}
          </Button>
          {showArrow && (
            <Button
              color="primary"
              size="small"
              className={`themed-button`}
              style={buttonStyle}
              aria-controls={open ? 'split-button-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-label={t('dropdown.toggleAriaLabel')}
              aria-haspopup="menu"
              onClick={event => {
                handleToggle(menuID, text)
              }}
            >
              <ChevronDown />
            </Button>
          )}
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={'list'}
          transition
          className="dropdown-popper"
          modifiers={{
            flip: {
              enabled: true,
              allowedAutoPlacements: ['top', 'bottom'],
            },
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" className={`themed-menu`}>
                    {items.map((item, index) => (
                      <MenuItem
                        key={index}
                        tabIndex={0}
                        // onClick={(event) => handleClick }
                        onClick={event => {
                          // need to use this syntax to hoist up handleClick()
                          handleClick(item.id, item.label, item.link)
                        }}
                        component={Link}
                        href={item.link}
                        rel="noopener noreferrer"
                        target="_blank"
                        className={`themed-menu-link`}
                      >
                        {item.label}
                        <ExternalLink />
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </>
  )
}
